module.exports = __webpack_public_path__ + "img/client-10.64370722.png";